import WriteReview from "@Components/Pages/Common/Modal/WriteReview";
import {
  IAggregateRating,
  IPagination,
  IProduct,
} from "@Interfaces/Api/Product";
import { IReview } from "@Interfaces/Api/Review";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ApiReview } from "@Services/API/IndividualApi's/Review";
import Link from "next/link";
import router, { Router } from "next/router";
import { useEffect, useState } from "react";
import Review from "./Review";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Divider, Icon, useMediaQuery } from "@mui/material";
import { theme } from "@Definitions/Styled";
import Cookies from "js-cookie";
import ReviewAndRatingTitle from "./ReviewAndRatingTitle";
import { StyledText } from "@Styled/Pages/orders";
import EditIcon from "@mui/icons-material/Edit";

interface ReviesProps {
  productId: string;
  aggregateRating: IAggregateRating;
  product: IProduct;
}

export default function Reviews({
  productId,
  aggregateRating,
  product,
}: ReviesProps) {
  const [allReviews, setAllReviews] = useState<IReview[]>([]);
  const [pagination, setPagination] = useState<IPagination>();
  const [isReviewModalOpen, setIsReviewModalOpen] = useState<boolean>(false);
  const [pendingApprovalReview, setPendingApprovalReview] = useState<IReview>();
  const [myReview, setMyReview] = useState<IReview>();
  const [buttonSpinner, setButtonSpinner] = useState<boolean>(false);
  const [isRatingSubmitted, setIsRatingSubmitted] = useState<boolean>(false);
  const [isReview, setIsReview] = useState<boolean>(true);
  const userId = Cookies.get("userId");

  useEffect(() => {
    getAllReviews();
    if (userId) {
      getMyReview();
    }
  }, [productId]);

  const handleAddReview = () => {
    setIsRatingSubmitted(false);
    if (!userId) {
      router.push("/login");
    } else {
      setIsReviewModalOpen(true);
    }
  };

  const handleRatingSubmit = async (obj: any) => {
    if (myReview) {
      const object = {
        message: obj.message,
        title: obj.title,
        rating: obj.rating,
        productId: productId,
        status: myReview.status,
      };
      try {
        const response = await ApiReview.put!(myReview._id, object);
        setIsRatingSubmitted(true);
        if (response) {
          getAllReviews();
          getMyReview();
        }
      } catch (err) {
        setIsRatingSubmitted(false);
        console.log(err);
      }
    } else {
      const object = {
        message: obj.message,
        title: obj.title,
        rating: obj.rating,
        productId: productId,
      };

      try {
        const response = await ApiReview.post!(object);
        if (response) {
          setIsRatingSubmitted(true);
          getMyReview();
        }
      } catch (err) {
        setIsRatingSubmitted(false);
        setButtonSpinner(false);
        console.log(err);
      }
    }
  };

  const handleReviewSubmit = async (obj: IReview) => {
    setButtonSpinner(true);

    if (!pendingApprovalReview && myReview) {
      const newObject = {
        message: obj.message,
        title: obj.title,
        rating: obj.rating,
        productId: productId,
        status: myReview.status,
      };
      try {
        const response = await ApiReview.put!(myReview._id, newObject);
        setIsReviewModalOpen(false);
        getAllReviews();
        getMyReview();
        setButtonSpinner(false);
      } catch (err) {
        setButtonSpinner(false);
        console.log(err);
      }
    } else if (pendingApprovalReview) {
      const object = {
        message: obj.message,
        title: obj.title,
        rating: obj.rating,
        productId: productId,
        status: pendingApprovalReview.status,
      };
      setPendingApprovalReview(undefined);
      try {
        const response = await ApiReview.put!(
          pendingApprovalReview._id,
          object
        );
        setIsReviewModalOpen(false);
        getAllReviews();
        getMyReview();
        setButtonSpinner(false);
      } catch (err) {
        setButtonSpinner(false);
        console.log(err);
      }
    }
  };

  const getMyReview = async () => {
    try {
      const response = await ApiReview.myReview!(productId);
      setIsReview(false);
      if (response.status == "PENDING" || response.status == "REJECTED") {
        setPendingApprovalReview(response);
        setMyReview(response);
      }
      if (router.query.addreview == "true" && isReview) {
        setIsReviewModalOpen(true);
      }
      setMyReview(response);
    } catch (err) {
      if (router.query.addreview == "true" && isReview) {
        setIsReviewModalOpen(true);
      }
      setPendingApprovalReview(undefined);
      console.log(err);
    }
  };

  async function getAllReviews() {
    try {
      // get reviews by productId
      const response = await ApiReview.getAllByProductId!(
        productId,
        1,
        2,
        "&onlyApprovedNonEmptyReview=true"
      );
      setAllReviews(response.data);
      setPagination(response.pagination);
    } catch (err) {
      console.log(err);
    }
  }

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Box>
      {!isMobile ? (
        <ReviewAndRatingTitle
          productId={productId}
          aggregateRating={aggregateRating}
          product={product}
          allReviews={allReviews}
          pagination={pagination!}
        />
      ) : (
        ""
      )}
      <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
        {/* <StyledLightGreenButton
          type="submit"
          onClick={handleAddReview}
          style={{
            width: "auto",
          }}
        >
          Write a review
        </StyledLightGreenButton> */}
        {!myReview ? (
          <StyledText
            as="a"
            style={{
              marginTop: "0.5rem",
              display: "flex",
              alignItems: "center",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={handleAddReview}
          >
            Add review
            <Icon component={EditIcon} style={{ fontSize: "0.8rem" }} />
          </StyledText>
        ) : (
          ""
        )}
      </Box>

      <Review
        review={allReviews}
        pendingApprovalReview={pendingApprovalReview}
        myReview={myReview!}
        handleEditReview={handleAddReview}
      />
      {product.aggregateRating &&
        product.aggregateRating.ratingValue > 0 &&
        pagination &&
        pagination?.totalCount > 2 && (
          <>
            <Divider
              variant="fullWidth"
              sx={{
                margin: "0.5rem 0rem 1rem 0rem",
                width: { xs: "100%" },
                height: "1px",
                background: theme.palette.secondary.main,
              }}
            />
            <Link href={`/reviews-and-rating/${product.slug}`}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: { sm: "1.2rem", xs: "0.9rem" },
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                Load more
                <Icon
                  component={ArrowForwardIosIcon}
                  sx={{
                    marginLeft: "0.5rem",
                    fontSize: { sm: "0.9rem", xs: "0.7rem" },
                    marginTop: "5px",
                  }}
                />{" "}
              </Typography>
            </Link>
          </>
        )}
      {isReviewModalOpen ? (
        <WriteReview
          handleClose={() => {
            setIsReviewModalOpen(false);
            setIsRatingSubmitted(false);
          }}
          isRatingSubmitted={isRatingSubmitted}
          open={isReviewModalOpen}
          myReview={myReview}
          handleReviewSubmit={handleReviewSubmit}
          buttonSpinner={buttonSpinner}
          handleRatingSubmit={handleRatingSubmit}
        />
      ) : (
        ""
      )}
    </Box>
  );
}
